import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { PaginationParams } from '../types/common';

export class BaseApiService {
  protected axios: AxiosInstance;
  protected endpoint: string;

  constructor(endpoint: string, axios: AxiosInstance = axiosInstance) {
    this.axios = axios;
    this.endpoint = endpoint;
  }

  protected async get<T>(path: string = '') {
    const { data } = await this.axios.get<T>(`${this.endpoint}${path}`);
    return data;
  }

  protected async getPaginated<T>(params: PaginationParams ,path ="") {

    const { data } = await this.axios.get(
      `${this.endpoint}${path}`,
      { params }
    );
    return data;
  }

  protected async post<T, D = unknown>(path: string = '', payload?: D) {
    const { data } = await this.axios.post<T>(`${this.endpoint}${path}`, payload);
    return data;
  }

  protected async put<T, D = unknown>(path: string = '', payload?: D) {
    const { data } = await this.axios.put<T>(`${this.endpoint}${path}`, payload);
    return data;
  }

  protected async patch<T, D = unknown>(path: string = '', payload?: D) {
    const { data } = await this.axios.patch<T>(`${this.endpoint}${path}`, payload);
    return data;
  }

  protected async delete<T>(path: string = '') {
    const { data } = await this.axios.delete<T>(`${this.endpoint}${path}`);
    return data;
  }
}
